<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Бино фойдаланиш тури <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="dictionaryData.data.category"
                                :class="{invalid : $v.dictionaryData.data.category.$error}"
                        >
                            <option value="Residential">Турар жой</option>
                            <option value="Notorious">Нотурар жой</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.category.$error">
                            Бино фойдаланиш турини танланг
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Регион тури <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="dictionaryData.data.regionType"
                                :class="{invalid : $v.dictionaryData.data.regionType.$error}"
                        >
                            <option value="TASHKENT_CITY">Тошкент шаҳри</option>
                            <option value="PROVINCE_CITY">Нукус шаҳри ва вилоят марказларидаги шаҳарлар</option>
                            <option value="OTHER_REGION">Бошқа аҳоли пунктлари</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.regionType.$error">
                            Регион турини танланг
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Қарор сони <span class="red">*</span></label>
                        <input class="form-control" type="text"
                               v-model="dictionaryData.data.decisionNumber"
                               :class="{invalid: $v.dictionaryData.data.decisionNumber.$error}"
                        />
                    </div>
                    <div class="form-group">
                        <label>Қарор санаси <span class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy"
                                    v-model="decisionDate"
                                    :clear-button="true"
                                    :class="{invalid : $v.decisionDate.$error}">
                        </datepicker>
                    </div>
                </div>
                <div>
                    <DropZone code="rentalRatesForLegal"
                              folder="Settings"
                              subFolder="RentalRatesApplication"
                              label="Илова *"
                              view="BUILDING" :data="dictionaryData.applications"
                              @change="(photos) => {dictionaryData.applications = photos}"
                              :has-error="$v.dictionaryData.applications.$error"
                    />
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" :disabled="processing">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="close">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required, minLength} from 'vuelidate/lib/validators';
    import DropZone from '@/views/dropZone/DropZone'
    import Datepicker from 'vuejs-datepicker';
    import {formatDate} from '@/shared/utils';

    export default {
        components: {
            'b-modal': bModal,
            DropZone,
            Datepicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                dictionaryData: this.initData(),
                decisionDate: null
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        category: {
                            required: required
                        },
                        regionType: {
                            required: required
                        },
                        decisionNumber: {
                            required: required
                        }
                    },
                    applications: {
                        required: required,
                        minLength: minLength(1)
                    }
                },
                decisionDate: {
                    required: required
                }
            }
        },
        computed: {
            getShortProvinces() {
                return this.provinces.map(province => ({id: province.id, name: province.name}))
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'RENTAL_RATES_APPLICATION_FOR_PHYSICAL',
                    data: {
                        category: null,
                        regionType: null,
                        decisionNumber: ''
                    },
                    applications: []
                }
            },
            save() {

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                if (this.decisionDate) {
                    this.dictionaryData.data.decisionDate = formatDate(this.decisionDate);
                }

                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save/real-estate/rental-rates',this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change')
                        }
                        vm.processing = false;
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });

            },
            close() {
                this.show = false
            }
        },
        created() {
            this.$eventBus.$on("showRRApplicationPhysicalEditModal", (data) => {
                if (data) {
                    console.log(data)
                } else {
                    this.dictionaryData = this.initData();
                    this.decisionDate = null;
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>